import { render, staticRenderFns } from "./adList.vue?vue&type=template&id=2696162a"
import script from "./adList.vue?vue&type=script&lang=js"
export * from "./adList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports